module.exports = {"510422100":"桐子林镇","510422101":"红格镇","510422102":"渔门镇","510422103":"永兴镇","510422200":"益民乡","510422201":"新九乡","510422202":"和爱彝族乡","510422203":"红果彝族乡","510422204":"鳡鱼彝族乡","510422205":"共和乡","510422206":"国胜乡","510422207":"红宝苗族彝族乡","510422208":"惠民乡","510422209":"箐河傈僳族乡","510422210":"温泉彝族乡","510422211":"格萨拉彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510422.json
// module id = 2285
// module chunks = 0